import React from 'react'
import { Link } from "react-router-dom";


const Partners = () => {
    return (
        <div className='pt-10 relative'>


            {/* <div className="absolute mt-[75px] h-full w-full -z-10 hidden lg:block">
                <img src="./assets/bg_blue.png" alt="" className="object-fill h-full w-full absolute top-0 -z-20" />
                <img src="./assets/bg_green.png" alt="" className="object-fill h-full w-full absolute top-0 -z-40" />

            </div> */}
            <div className="min-h-screen py-20 xl:px-[120px] px-5">
                <div className="flex gap-4 justify-between items-center ">
                    <Link to="/">
                        <div className="flex gap-2 items-center cursor-pointer">
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M19 11.4997H7.82999L12.71 6.61967C13.1 6.22967 13.1 5.58967 12.71 5.19967C12.6175 5.10697 12.5076 5.03342 12.3866 4.98324C12.2656 4.93306 12.136 4.90723 12.005 4.90723C11.874 4.90723 11.7443 4.93306 11.6234 4.98324C11.5024 5.03342 11.3925 5.10697 11.3 5.19967L4.70999 11.7897C4.61728 11.8822 4.54373 11.9921 4.49355 12.113C4.44337 12.234 4.41754 12.3637 4.41754 12.4947C4.41754 12.6256 4.44337 12.7553 4.49355 12.8763C4.54373 12.9973 4.61728 13.1072 4.70999 13.1997L11.3 19.7897C11.3926 19.8823 11.5025 19.9557 11.6234 20.0058C11.7444 20.0559 11.8741 20.0817 12.005 20.0817C12.1359 20.0817 12.2656 20.0559 12.3865 20.0058C12.5075 19.9557 12.6174 19.8823 12.71 19.7897C12.8026 19.6971 12.876 19.5872 12.9261 19.4662C12.9762 19.3453 13.002 19.2156 13.002 19.0847C13.002 18.9537 12.9762 18.8241 12.9261 18.7031C12.876 18.5822 12.8026 18.4723 12.71 18.3797L7.82999 13.4997H19C19.55 13.4997 20 13.0497 20 12.4997C20 11.9497 19.55 11.4997 19 11.4997Z"
                                    fill="#11485B"
            />
          </svg>
          <p className="text-[#11485B] font-[600]">Back</p>
                        </div>
                    </Link>

                    <p className=" md:text-[24px] text-[18px] text-[#234971] font-[700] my-5 text-center flex-1">
                        OUR PARTNERS
                    </p>
                </div>

                <p className="text-[#234971]  md:text-[20px] text-[18px] font-[400] text-justify ">At <span className='font-[700]'>AQUA Medical Laboratories,</span> we are proud to collaborate with a network of esteemed partners who share our commitment to excellence in healthcare. Our partnerships with leading hospitals, research institutions, and healthcare providers enable us to deliver cutting-edge diagnostics and innovative solutions. Together, we strive to enhance patient care and advance medical science. Thank you to our partners for their invaluable support and collaboration.</p>
                <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-10 mt-10 ">
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img1.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img2.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img3.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img4.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img5.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img6.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img7.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img8.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img9.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img10.png" alt="image" className='w-[100px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img11.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                    <div className="shadow-xl w-[100%] md:h-[160px] h-[120px] flex justify-center items-center bg-white">
                        <img src="./assets/partners/img12.png" alt="image" className='w-[200px] h-ful' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Partners
